export const clients = {
  addressType: {
    'establishment unit': 'Vestigingseenheid',
    headquarters: 'Maatschappelijke zetel',
  },
  alerts: {
    errorKboInformation: 'Er ging iets mis bij het ophalen van de bedrijfsgegevens. Probeer je het later nog eens?',
    errorViesInformation: 'Er ging iets mis bij het ophalen van de bedrijfsgegevens. Probeer je het later nog eens?',
    successContactCreated: 'Je contactpersoon is aangemaakt.',
    successContactDeleted: 'Je contactpersoon is verwijderd.',
    successContactEditedOrganisation: 'Je contactpersoon is bewerkt.',
    successContactEditedPrivate: 'Je klant is bewerkt.',
    successCreated: 'Je klant is aangemaakt.',
    successDeleted: 'Je klant is verwijderd.',
    successUpdated: 'Je klant is bewerkt.',
  },
  breadcrumb: {
    create: 'Nieuwe klant',
    createContact: 'Nieuwe contactpersoon',
    edit: 'Klant bewerken',
    editContact: 'Contactpersoon bewerken',
    overview: 'Klanten',
    show: 'Klantdetails',
  },
  card: {
    address: 'Adres',
    label: 'Klant',
  },
  contact: 'Contactpersoon',
  create: {
    blocker: 'Ben je zeker dat je de pagina wilt verlaten? Je klant is niet opgeslagen.',
    chooseType: {
      organisation: {
        description: 'Voeg een organisatie met contactpersoon toe',
        title: 'Organisatie',
      },
      private: {
        description: 'Voeg een particuliere klant of feitelijke vereniging toe',
        title: 'Particulier',
      },
      title: 'Kies type klant',
    },
    company: {
      changeVatNumber: 'Niet wat je zoekt? Geef een ander btw-nummer in.',
      companyInformationDisclaimer:
        'Deze gegevens vonden we terug, op basis van het btw-nummer. Extra (persoons)gegevens voeg je toe in de volgende stap.',
      companyInformationDisclaimerWithoutAddress:
        'Bovenstaande organisatie vonden we op basis van het btw-nummer. Het adres van de maatschappelijke zetel ontbreekt nog, vul je dit nog even in of vraag je dit op?',
      hasVatNumberLink: 'Btw-nummer?',
      noVatNumberLink: 'Geen btw-nummer?',
      searchCompanyInformation: 'Opzoeken',
      switchToOtherNumber: 'Heeft je klant geen btw-nummer? <0>Klik hier om een ander nummer in te vullen.</0>',
      switchToVatNumber: 'Heeft je klant een btw-nummer? <0>Klik hier om te zoeken op btw-nummer.</0>',
    },
    next: 'Volgende',
    previous: 'Vorige',
    save: 'Opslaan',
    submit: 'Klant aanmaken',
    title: 'Nieuwe klant',
    type: {
      contact: 'Contactpersoon',
      organisation: 'Organisatie',
    },
  },
  createContact: {
    blocker: 'Ben je zeker dat je de pagina wilt verlaten? Je contactpersoon is niet opgeslagen.',
    submit: 'Contactpersoon toevoegen',
  },
  createEdit: {
    subsections: {
      comments: {
        description: 'Hou hier klantennotities bij, over bijvoorbeeld een afwijkende betalingstermijn, speciale afspraken …',
        fieldFootnote: 'Enkel zichtbaar voor jou.',
        fieldLabel: 'Notities',
        title: 'Notities',
      },
      contactAddress: 'Adres',
      customAgreement: {
        description:
          'Heb je een bestaande raamovereenkomst met je klant die langer duurt dan 6 maanden? Vink het aan. Meer info en waarom dit belangrijk is voor ons? <a href="https://knowledge.creativeshelter.be/opdrachtgevers-en-overeenkomsten-wij-zetten-je-op-weg" target="_blank">Lees het hier.</a>',
        title: 'Raamovereenkomst',
      },
      emails: {
        description: 'Kies zelf wie welke communicatie ontvangt, of ontvang ze liever zelf.',
        title: 'E-mails',
      },
      personalInfo: 'Persoonlijke gegevens',
    },
  },
  customAgreementDialog: {
    cancel: 'Nee, ga terug',
    description:
      'Bevestig enkel als je met deze klant al een getekende overeenkomst hebt. Wij sturen je hierna een e-mail om de overeenkomst na te lezen. Meer info waarom dit belangrijk is, <a href="https://knowledge.creativeshelter.be/opdrachtgevers-en-overeenkomsten-wij-zetten-je-op-weg" target="_blank">lees je hier</a>.',
    submit: 'Ja, ik heb een getekende overeenkomst',
    title: 'Let op!',
  },
  detail: {
    contacts: {
      add: 'Contactpersoon toevoegen',
      columns: {
        email: 'E-mailadres',
        name: 'Naam',
        phoneNumber: 'Telefoonnummer',
      },
      delete: {
        description: 'Ben je zeker dat je contactpersoon “{{name}}” wilt verwijderen?',
        submit: 'Verwijder contactpersoon',
        title: 'Contactpersoon verwijderen',
      },
      moreEmails: 'En nog {{amount}} andere',
      rowActions: {
        duplicate: 'Kopiëren',
      },
      selfEmail: '{{email}} (jijzelf)',
      title: 'Contactpersonen ({{amount}})',
    },
    info: {
      creditsafe: {
        creditRating: {
          label: 'Kredietwaardigheid',
          tooltip:
            'Deze score geeft inzichten in de financiën van je klant.\n<faqLink href="https://knowledge.creativeshelter.be/creditsafe-wat-zegt-dat-precies-over-je-opdrachtgever">Lees er hier meer over.</faqLink>',
        },
        score: {
          '?': {
            text: 'Geen informatie',
          },
          A: {
            text: 'Heel laag risico',
          },
          B: {
            text: 'Laag risico',
          },
          C: {
            text: 'Gemiddeld risico',
          },
          D: {
            text: 'Hoger risico',
          },
        },
        status: {
          Error: 'De kredietscore kan niet opgehaald worden.',
          NotFetched: 'De kredietscore wordt opgehaald.',
        },
      },
      edit: {
        action: 'Organisatie bewerken',
      },
      refreshVatInformation: {
        ariaLabel: 'Bedrijfsgegevens opnieuw ophalen',
        lastUpdated: '{{timeAgo}} geüpdatet uit de KBO',
        tooltip: {
          notRefreshable:
            'Haal de nieuwste gegevens van je klant op uit de <kboLink>Kruispuntbank van Ondernemingen</kboLink>.<br/>(Dat kan alleen als de gegevens meer dan 7 dagen oud zijn.)',
          refreshable: 'Haal de nieuwste gegevens van je klant op uit de <kboLink>Kruispuntbank van Ondernemingen</kboLink>.',
        },
      },
    },
    invoices: {
      title: 'Facturen',
      titleWithCount: 'Facturen ({{amount}})',
    },
  },
  editClient: {
    blocker: 'Ben je zeker dat je de pagina wilt verlaten? De wijzigingen aan je klant zijn niet opgeslagen.',
  },
  editContact: {
    blocker: 'Ben je zeker dat je de pagina wilt verlaten? De wijzigingen aan je contactpersoon zijn niet opgeslagen.',
  },
  fields: {
    address: {
      label: 'Adres',
    },
    city: {
      label: 'Gemeente',
    },
    companyName: {
      label: 'Bedrijfsnaam',
    },
    countryCode: {
      groups: {
        europe: 'Europa',
        europeanUnion: 'Europese Unie',
        international: 'Internationaal',
      },
      label: 'Land',
      placeholder: 'Selecteer een land',
    },
    customAgreement: {
      label: 'Ik heb een bestaande raamovereenkomst met deze klant.',
      tooltip: 'Afspraken korter dan 6 maanden of eenmalige afspraken vallen hier niet onder.',
    },
    emailAddresses: {
      addReceiver: 'Extra ontvanger toevoegen',
      addSelf: 'Zelf versturen',
      invoicesAndCreditNotes: 'Facturen en creditnota’s',
      label: 'E-mailadres',
      paymentReminders: 'Betalingsherinneringen',
      peppolDisclaimer:
        'Je klant ontvangt facturen en creditnota’s via Peppol. Via hun e-mailadres informeren we hen dat het document terug te vinden is in hun Peppol-inbox.',
      placeholder: 'Vul het e-mailadres in',
      quotations: 'Offertes',
    },
    enterpriseNumber: {
      label: 'Btw- of ondernemingsnummer',
    },
    firstName: {
      label: 'Voornaam',
      placeholder: 'Voornaam',
    },
    function: {
      label: 'Functie',
      placeholder: 'Functie',
    },
    lang: {
      label: 'Taal',
    },
    lastName: {
      label: 'Achternaam',
      placeholder: 'Achternaam',
    },
    number: {
      label: 'Huisnummer',
    },
    organisationName: {
      add: 'Feitelijke vereniging',
      label: 'Naam organisatie',
      tooltip: 'Is je klant een feitelijke vereniging? Vul hier de naam van de vereniging in.',
    },
    otherNumber: {
      label: 'Ander nummer',
      placeholder: 'Ander nummer',
    },
    street: {
      label: 'Straat',
    },
    telephone: {
      label: 'Telefoonnummer',
      placeholder: 'Telefoonnummer',
    },
    useOrganisationAddress: {
      label: 'Gebruik het adres van de organisatie',
    },
    userComments: {
      placeholder: 'Opmerking/reminder voor jezelf',
    },
    vatNumber: {
      label: 'Btw-nummer',
    },
    vatOrOtherNumber: {
      label: 'Btw- of ander type nummer',
    },
    zipcode: {
      label: 'Postcode',
    },
  },
  header: {
    actionBlock: {
      button: 'Klant aanmaken',
    },
    title: 'Klanten',
  },
  overview: {
    columns: {
      contacts: 'Contactpersonen',
      name: 'Naam',
      type: 'Type klant',
      vatOrOtherNumber: 'Btw- of ander type nummer',
    },
    delete: {
      description: 'Ben je zeker dat je “{{name}}” wilt verwijderen?',
      submit: 'Verwijder klant',
      title: 'Klant verwijderen',
    },
    moreContacts: 'En nog {{amount}} andere',
    rowActions: {
      addContact: 'Contactpersoon toevoegen',
      view: 'Bekijken',
    },
    vat: {
      mailTooltip: 'Deze onderneming is nog niet aangesloten op het Peppol-netwerk. Daarom versturen we de factuur via e-mail.',
      peppolTooltip: 'Deze onderneming is aangesloten op het Peppol-netwerk. Facturen en creditnota’s worden via Peppol verstuurd.',
    },
  },
  peppol: {
    status: {
      active: 'Actief',
      error: 'We konden het Peppol-ID van je klant niet ophalen.',
      label: 'Peppol',
      notRegistered: 'Nog niet geregistreerd op Peppol',
      pending: 'Peppol-ID ophalen…',
      tooltip: {
        active:
          "Is je klant actief op Peppol? Dan worden facturen en creditnota’s automatisch verstuurd via het Peppol-netwerk. Lees er <faqLink href='https://www.creativeshelter.be/knowledge-hub/sturen-jullie-facturen-via-peppol-mercuriusplatform-e-invoicing'>hier alles over</faqLink>.",
        notRegistered: 'Je klant is nog niet geregistreerd op Peppol. Daarom versturen we facturen voorlopig via e-mail.',
      },
    },
  },
  type: {
    organisation: 'Organisatie',
    private: 'Particulier',
  },
};
